var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var appointmentCollection = require('./appointmentCollection');

/**
 * Data Behavior hooked up to the appointment cache.
 * @class AppointmentDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: appointmentCollection
});
